import type { RefObject } from 'react';
import { FILTER_COLUMN_BREAKPOINTS } from '@/components/common/filterFieldsGrid.constants';
import { useElementWidth } from './useElementWidth';

const SINGLE_COLUMN = 1;
const DEFAULT_ROOT_FONT_SIZE_PX = 16;

function getRootFontSizePx(): number {
  const fontSize = Number.parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number.isFinite(fontSize) ? fontSize : DEFAULT_ROOT_FONT_SIZE_PX;
}

function toColumnCount(widthPx: number): number {
  const widthRem = widthPx / getRootFontSizePx();
  const breakpoint = FILTER_COLUMN_BREAKPOINTS.find(
    (candidate) => widthRem >= candidate.minWidthRem,
  );
  return breakpoint?.columnCount ?? SINGLE_COLUMN;
}

export function useFilterColumnCount(containerRef: RefObject<HTMLElement | null>): number {
  const widthPx = useElementWidth(containerRef);
  return widthPx === undefined ? SINGLE_COLUMN : toColumnCount(widthPx);
}
